import { ButtonBase } from "@material-ui/core";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import _ from "lodash";
import fp from "lodash/fp";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import changeCartDrawer from "../../../redux/actions/changeCartDrawer";
import removeFromCart from "../../../redux/actions/removeFromCart";

export const styles = (theme) => ({
	badge: {
		transform: "scale(1.2) translate(50%, -26%)",
		fontFamily: "Lato",
		backgroundColor: theme.palette.alert.dark,
		fontWeight: "800",
	},
	hideBadge: {
		transform: "scale(0) translate(50%, -50%)",
		transition: "transform 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
		transformOrigin: "100% 0%",
	},
	badgeBackground: {
		width: 50,
		height: 50,
		...theme.mixins.breakpoints.tablet({
			marginLeft: 0,
		}),
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		borderRadius: "24px",
		cursor: "pointer",
		"&:hover": {
			backgroundColor: theme.palette.grey[100],
		},
	},
	buttonRoot: {
		marginLeft: 23,
		padding: "0 !important",
	},
});

/**
 * CartIcon React Component
 * @param {Object} props - artIconBase props
 * @returns {React.Component} CartIcon
 */
export const CartIcon = (props) => {
	const { classes, onChangeCartDrawer, cart } = props;

	const handleCartDrawer = () => {
		if (cart.isDrawerOpen) {
			onChangeCartDrawer(false);
		} else {
			onChangeCartDrawer(true);
		}
	};

	const cartSize = _.get(cart, "items", []).length;

	return (
		<ButtonBase classes={{ root: classes.buttonRoot }} onClick={handleCartDrawer} aria-label="Shopping cart">
			<div className={classes.badgeBackground}>
				<Badge
					classes={cartSize === 0 ? { badge: classes.hideBadge } : { badge: classes.badge }}
					badgeContent={cartSize}
					color="primary"
					overlap="rectangular"
				>
					<ShoppingCartIcon />
				</Badge>
			</div>
		</ButtonBase>
	);
};

CartIcon.propTypes = {
	onChangeCartDrawer: PropTypes.func.isRequired,
	classes: PropTypes.shape({}).isRequired,
	cart: PropTypes.shape({
		isDrawerOpen: PropTypes.bool.isRequired,
		items: PropTypes.array.isRequired,
	}).isRequired,
};

export const mapStateToProps = ({ cart }) => ({ cart });

export const mapDispatchToProps = {
	onRemoveCartItem: removeFromCart,
	onChangeCartDrawer: changeCartDrawer,
};

export default fp.compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(CartIcon);
